import { render, staticRenderFns } from "./profitTableSpecialty.vue?vue&type=template&id=6a920202&scoped=true"
import script from "./profitTableSpecialty.vue?vue&type=script&lang=js"
export * from "./profitTableSpecialty.vue?vue&type=script&lang=js"
import style0 from "./profitTableSpecialty.vue?vue&type=style&index=0&id=6a920202&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a920202",
  null
  
)

export default component.exports